import script from "./index404.vue?vue&type=script&lang=ts&setup=true"
export * from "./index404.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__